import { FaShare } from "react-icons/fa";
import useSbConfig from "../Shared/useSbConfig";
import ActionButton from "../Shared/ActionButton";

export default ({
  inventoryItem
}) => {
  const {
    id
  } = inventoryItem

  const sbConfig = useSbConfig()

  const viewInventoryItem = () => {
    // 1.0 ${sbConfig.merchantUrl}/app/merchant/#/inventory-status/all?option=Active&pageNumber=1&pageSize=25&filter=Search+eq+${id}
    // 2.0 Same url, but search doesn't work -_-
    window.open(`${sbConfig.merchantUrl}/app/merchant/#/inventory-status/all?option=Active&pageNumber=1&pageSize=25&filter=Search+eq+${id}`)
  }

  return (
    <ActionButton onClick={viewInventoryItem}>
      <FaShare style={{ paddingRight: '10px' }} />
      View
    </ActionButton>
  )
}